var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React from 'react';
import GeolocationViewer from "./GeolocationViewer";
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Translate } from "../../I18N";
import { bindActionCreators } from 'redux';

import { ensure } from "../../../shared/tsUtils";
import { Pill } from "./Pill";
import * as actions from "../../Relationships/actions/actions";






























const templatesMap = createSelector(
  (s) => s.templates,
  (templates) =>
  templates.reduce(
    (map, template) => _objectSpread(_objectSpread({},
    map), {}, {
      [ensure(template === null || template === void 0 ? void 0 : template.get('_id'))]: {
        name: template === null || template === void 0 ? void 0 : template.get('name'),
        color: template === null || template === void 0 ? void 0 : template.get('color')
      } }),

    {}
  )
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      selectConnection: actions.selectConnection
    },
    dispatch
  );
}

const mapStateToProps = (state) => ({
  templatesInfo: templatesMap(state)
});

const connector = connect(mapStateToProps, mapDispatchToProps);


const notLabeledOrMultiple = (member) =>
member.value.length === 1 && !member.value[0].label;

const pillColor = (member, templatesInfo, templateId) => {var _templatesInfo$member;return (
    ((_templatesInfo$member = templatesInfo[member.translateContext]) === null || _templatesInfo$member === void 0 ? void 0 : _templatesInfo$member.color) || templatesInfo[templateId].color);};

const getFirstGroupInfo = (
members,
templatesInfo,
templateId) => /*#__PURE__*/

_jsx("dl", {
  className: "pills-container" },
members.map((member) => `${member.translateContext}_${member.name}`).join(','), /*#__PURE__*/

_jsx("dt", {}), /*#__PURE__*/
_jsx("dd", {}, void 0,
members.map((member) => /*#__PURE__*/
_jsx(Pill, {

  color: pillColor(member, templatesInfo, templateId) }, `${member.value[0].lat}_${member.value[0].lon}`, /*#__PURE__*/

_jsx(Translate, { context: templateId }, void 0, member.label)
)
)
)
);


const getMultiMemberInfo =
(
templatesInfo,
selectConnection,
templateId) =>

(member) => {var _templatesInfo$member2;return (/*#__PURE__*/
    _jsx("dl", { className: "pills-container" }, `${member.translateContext}_${member.name}`, /*#__PURE__*/
    _jsx("dt", {}, void 0, /*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx(Translate, { context: templateId }, void 0, member.label),
    ((_templatesInfo$member2 = templatesInfo[member.translateContext]) === null || _templatesInfo$member2 === void 0 ? void 0 : _templatesInfo$member2.name) && /*#__PURE__*/
    React.createElement(React.Fragment, null,
    ' (', /*#__PURE__*/
    _jsx(Translate, {}, void 0, "linked"), ' ', /*#__PURE__*/
    _jsx(Translate, { context: templateId }, void 0,
    templatesInfo[member.translateContext].name
    ),
    ') '
    )

    )
    ), /*#__PURE__*/
    _jsx("dd", {}, void 0,
    member.value.map((value) => /*#__PURE__*/
    _jsx("div", {

      onClick: () => value.relatedEntity && selectConnection(value.relatedEntity),
      style: { cursor: value.relatedEntity ? 'pointer' : 'default' } }, `${value.lat}_${value.lon}`, /*#__PURE__*/

    _jsx(Pill, {

      color: pillColor(member, templatesInfo, templateId) }, `${value.lat}_${value.lon}`, /*#__PURE__*/

    _jsx(Translate, { context: member.translateContext }, void 0, value.label || '')
    )
    )
    )
    )
    ));};


const computeRenderMemberGroups = (
members,
templatesInfo,
selectConnection,
templateId) =>
{
  const firstGroup = [];
  const restOfGroups = [];

  members.forEach((member) => {
    if (notLabeledOrMultiple(member)) {
      firstGroup.push(member);
    } else {
      restOfGroups.push(member);
    }
  });

  return [
  firstGroup.length ? getFirstGroupInfo(firstGroup, templatesInfo, templateId) : null].
  concat(restOfGroups.map(getMultiMemberInfo(templatesInfo, selectConnection, templateId)));
};

// eslint-disable-next-line react/no-multi-comp
const GroupedGeolocationViewerComponent = (props) => {
  const markers = props.members.reduce((flat, member) => {
    if (notLabeledOrMultiple(member)) {
      return flat.concat([_objectSpread(_objectSpread({},

      member.value[0]), {}, {
        label: member.label,
        color: pillColor(member, props.templatesInfo, props.templateId) })]

      );
    }

    return flat.concat(
      member.value.map((v) => _objectSpread(_objectSpread({},
      v), {}, {
        color: pillColor(member, props.templatesInfo, props.templateId) })
      )
    );
  }, []);

  return (/*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(GeolocationViewer, { points: markers, onlyForCards: false }),
    computeRenderMemberGroups(
      props.members,
      props.templatesInfo,
      props.selectConnection,
      props.templateId
    )
    ));

};

export const GroupedGeolocationViewer = connector(GroupedGeolocationViewerComponent);